/*
 * Store Experts — Brindes automáticos Beout V14.
 *
 * Centraliza todas as campanhas de brinde do tema no mesmo ciclo AJAX.
 *
 * Campanhas suportadas:
 * 1) Brinde automático por valor mínimo (legado do tema);
 * 2) Dia do Cliente (mantida sem alteração de regra): valor mínimo apenas em
 *    produtos com a tag configurada + janela de data/horário;
 * 3) Brinde por valor + tag: novo controle independente com produto de brinde;
 * 4) Brinde por quantidade + tag;
 * 5) Segundo brinde por quantidade: tag opcional e exclusão de tags.
 *
 * As campanhas com produto selecionável protegem o produto de brinde no carrinho: uma única
 * unidade, remoção automática ao perder elegibilidade/estoque/período e linha
 * promocional sem controles de quantidade/remoção.
 */
(function () {
  'use strict';

  var CONFIG_ID = 'BeoutGiftCampaignsConfig';
  var ROLE_KEY = '_beout_gift_role';
  var VARIANT_KEY = '_beout_gift_variant_id';
  var BADGE_KEY = '_beout_gift_badge_text';
  var SOURCE_KEY = '_beout_gift_source';
  var AUTO_ROLE = 'automatic_gift';
  var DIA_ROLE = 'dia_cliente_gift';
  var TAG_VALUE_ROLE = 'tag_value_gift';
  var TAG_QUANTITY_ROLE = 'tag_quantity_gift';
  var QUANTITY_2_ROLE = 'quantity_2_gift';
  var THEME_GIFT_ROLES = [AUTO_ROLE, DIA_ROLE, TAG_VALUE_ROLE, TAG_QUANTITY_ROLE, QUANTITY_2_ROLE];
  var MAX_PASSES = 10;
  var PRODUCT_CACHE_TTL = 5000;

  function toNumber(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) ? number : (fallback || 0);
  }

  function parseMoneyToCents(value) {
    var raw = String(value == null ? '' : value).trim().replace(/\s+/g, '');
    if (!raw) return 0;

    var comma = raw.lastIndexOf(',');
    var dot = raw.lastIndexOf('.');
    var normalized = raw;

    if (comma > -1 && dot > -1) {
      normalized = comma > dot
        ? normalized.replace(/\./g, '').replace(',', '.')
        : normalized.replace(/,/g, '');
    } else if (comma > -1) {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    }

    normalized = normalized.replace(/[^0-9.-]/g, '');
    var parsed = Number(normalized);
    return Number.isFinite(parsed) ? Math.max(0, Math.round(parsed * 100)) : 0;
  }

  // Matches complete tags, preserving accents and ignoring case/outer spaces.
  function normalizeTagList(value) {
    var tags = Array.isArray(value) ? value : String(value || '').split(/[,\r\n]+/);
    return tags.map(function (tag) { return String(tag || '').trim().toLowerCase(); }).filter(Boolean);
  }

  function parseCartState(value) {
    if (!value) return null;
    if (typeof value !== 'string') return value;

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function normalizeOffset(value) {
    var offset = String(value || '').trim();
    if (!offset) return '';
    if (/^[+-]\d{4}$/.test(offset)) return offset.slice(0, 3) + ':' + offset.slice(3);
    if (/^[+-]\d{2}:\d{2}$/.test(offset)) return offset;
    return '';
  }

  function normalizeDate(value) {
    var raw = String(value || '').trim();
    if (!raw) return '';

    if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

    var match = raw.match(/^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})$/);
    if (!match) return '';

    var day = String(match[1]).padStart(2, '0');
    var month = String(match[2]).padStart(2, '0');
    return match[3] + '-' + month + '-' + day;
  }

  function normalizeTime(value, fallback) {
    var raw = String(value || '').trim();
    var match = raw.match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return fallback || '00:00';

    var hour = Math.min(23, Math.max(0, toNumber(match[1])));
    var minute = Math.min(59, Math.max(0, toNumber(match[2])));
    return String(hour).padStart(2, '0') + ':' + String(minute).padStart(2, '0');
  }

  function campaignTimestamp(dateValue, timeValue, offsetValue, isEnd) {
    var date = normalizeDate(dateValue);
    if (!date) return null;

    var time = normalizeTime(timeValue, isEnd ? '23:59' : '00:00');
    var offset = normalizeOffset(offsetValue);
    var suffix = isEnd ? ':59.999' : ':00.000';
    var parsed = Date.parse(date + 'T' + time + suffix + offset);

    return Number.isFinite(parsed) ? parsed : null;
  }

  function readConfig() {
    var node = document.getElementById(CONFIG_ID);
    if (!node) return null;

    try {
      var data = JSON.parse(node.textContent || '{}');
      var automatic = data.automatic || {};
      var dia = data.diaCliente || {};
      var tagValue = data.tagValueGift || {};
      var tagQuantity = data.tagQuantityGift || {};
      var quantity2 = data.quantityGift2 || {};
      var protection = window.beoutQuantityGiftProtection && window.beoutQuantityGiftProtection.getState();
      if (protection && protection.catalogChecked && protection.productHandle === quantity2.productHandle) {
        quantity2.productId = protection.productId;
        quantity2.variantId = protection.variantId;
        quantity2.variantPrice = protection.variantPrice;
        quantity2.variantAvailable = protection.variantAvailable;
      }


      return {
        automatic: {
          id: 'automatic',
          role: AUTO_ROLE,
          source: 'theme_campaign_v13_automatic',
          qualificationType: 'cart_value',
          enabled: automatic.enabled === true,
          productId: Math.max(0, toNumber(automatic.productId)),
          productHandle: String(automatic.productHandle || '').trim(),
          variantId: Math.max(0, toNumber(automatic.variantId)),
          initialVariantId: Math.max(0, toNumber(automatic.variantId)),
          variantAvailable: automatic.variantAvailable !== false,
          minimumCents: parseMoneyToCents(automatic.minimumValueRaw),
          badgeText: String(automatic.badgeText || 'Brinde').trim() || 'Brinde',
          visualFree: automatic.visualFree === true,
          hasDateWindow: false,
          protectGiftProduct: false
        },
        diaCliente: {
          id: 'dia_cliente',
          role: DIA_ROLE,
          source: 'theme_campaign_v13_dia_cliente',
          qualificationType: 'tag_value',
          enabled: dia.enabled === true,
          productId: Math.max(0, toNumber(dia.productId)),
          productHandle: String(dia.productHandle || '').trim(),
          variantId: Math.max(0, toNumber(dia.variantId)),
          initialVariantId: Math.max(0, toNumber(dia.variantId)),
          variantAvailable: dia.variantAvailable !== false,
          minimumCents: parseMoneyToCents(dia.minimumValueRaw),
          requiredTag: String(dia.requiredTag || 'diadocliente').trim().toLowerCase(),
          badgeText: String(dia.badgeText || 'Brinde Dia do Cliente').trim() || 'Brinde Dia do Cliente',
          visualFree: dia.visualFree === true,
          startDate: String(dia.startDate || '').trim(),
          startTime: String(dia.startTime || '').trim(),
          endDate: String(dia.endDate || '').trim(),
          endTime: String(dia.endTime || '').trim(),
          storeUtcOffset: String(dia.storeUtcOffset || '').trim(),
          availabilityErrorUntil: 0,
          hasDateWindow: true,
          protectGiftProduct: true
        },
        tagValueGift: {
          id: 'tag_value',
          role: TAG_VALUE_ROLE,
          source: 'theme_campaign_v14_tag_value',
          qualificationType: 'tag_value',
          enabled: tagValue.enabled === true,
          productId: Math.max(0, toNumber(tagValue.productId)),
          productHandle: String(tagValue.productHandle || '').trim(),
          variantId: Math.max(0, toNumber(tagValue.variantId)),
          initialVariantId: Math.max(0, toNumber(tagValue.variantId)),
          variantAvailable: tagValue.variantAvailable !== false,
          minimumCents: parseMoneyToCents(tagValue.minimumValueRaw),
          requiredTag: String(tagValue.requiredTag || '').trim().toLowerCase(),
          badgeText: String(tagValue.badgeText || 'Brinde').trim() || 'Brinde',
          visualFree: tagValue.visualFree === true,
          startDate: String(tagValue.startDate || '').trim(),
          startTime: String(tagValue.startTime || '').trim(),
          endDate: String(tagValue.endDate || '').trim(),
          endTime: String(tagValue.endTime || '').trim(),
          storeUtcOffset: String(tagValue.storeUtcOffset || '').trim(),
          availabilityErrorUntil: 0,
          hasDateWindow: true,
          protectGiftProduct: true
        },
        tagQuantityGift: {
          id: 'tag_quantity',
          role: TAG_QUANTITY_ROLE,
          source: 'theme_campaign_v14_tag_quantity',
          qualificationType: 'tag_quantity',
          enabled: tagQuantity.enabled === true,
          productId: Math.max(0, toNumber(tagQuantity.productId)),
          productHandle: String(tagQuantity.productHandle || '').trim(),
          variantId: Math.max(0, toNumber(tagQuantity.variantId)),
          initialVariantId: Math.max(0, toNumber(tagQuantity.variantId)),
          variantAvailable: tagQuantity.variantAvailable !== false,
          minimumQuantity: Math.max(1, Math.floor(toNumber(tagQuantity.minimumQuantity, 2))),
          requiredTag: String(tagQuantity.requiredTag || '').trim().toLowerCase(),
          badgeText: String(tagQuantity.badgeText || 'Brinde').trim() || 'Brinde',
          visualFree: tagQuantity.visualFree === true,
          startDate: String(tagQuantity.startDate || '').trim(),
          startTime: String(tagQuantity.startTime || '').trim(),
          endDate: String(tagQuantity.endDate || '').trim(),
          endTime: String(tagQuantity.endTime || '').trim(),
          storeUtcOffset: String(tagQuantity.storeUtcOffset || '').trim(),
          availabilityErrorUntil: 0,
          hasDateWindow: true,
          protectGiftProduct: true
        },
        quantityGift2: {
          id: 'quantity_2',
          role: QUANTITY_2_ROLE,
          source: 'theme_campaign_v14_quantity_2',
          qualificationType: 'quantity_exclusions',
          enabled: quantity2.enabled === true,
          productId: Math.max(0, toNumber(quantity2.productId)),
          productHandle: String(quantity2.productHandle || '').trim(),
          variantId: Math.max(0, toNumber(quantity2.variantId)),
          initialVariantId: Math.max(0, toNumber(quantity2.variantId)),
          variantAvailable: quantity2.variantAvailable !== false,
          variantPrice: toNumber(quantity2.variantPrice, -1),
          expectedPriceCents: 10,
          minimumQuantity: Math.max(1, Math.floor(toNumber(quantity2.minimumQuantity, 2))),
          requiredTag: String(quantity2.requiredTag || '').trim().toLowerCase(),
          excludedTags: normalizeTagList(quantity2.excludedTags),
          badgeText: String(quantity2.badgeText || 'Brinde da promoção').trim() || 'Brinde da promoção',
          visualFree: false,
          startDate: String(quantity2.startDate || '').trim(),
          startTime: String(quantity2.startTime || '').trim(),
          endDate: String(quantity2.endDate || '').trim(),
          endTime: String(quantity2.endTime || '').trim(),
          storeUtcOffset: String(quantity2.storeUtcOffset || '').trim(),
          availabilityErrorUntil: 0,
          hasDateWindow: true,
          protectGiftProduct: true
        }
      };
    } catch (error) {
      console.error('[Store Experts][Brindes] Configuração inválida.', error);
      return null;
    }
  }

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    return String(root).replace(/\/?$/, '/');
  }

  function route(name) {
    if (window.theme && window.theme.routes) {
      if (name === 'add' && window.theme.routes.cart_add_url) return window.theme.routes.cart_add_url;
      if (name === 'update' && window.theme.routes.cart_update_url) return window.theme.routes.cart_update_url;
    }

    if (name === 'add') return rootUrl() + 'cart/add.js';
    if (name === 'update') return rootUrl() + 'cart/update.js';
    return rootUrl() + 'cart.js';
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || (payload && payload.status)) {
          var error = new Error(
            (payload && (payload.description || payload.message)) ||
            'Não foi possível atualizar o carrinho.'
          );
          error.status = (payload && payload.status) || response.status;
          throw error;
        }
        return payload;
      });
    });
  }

  var manager = {
    config: null,
    isSyncing: false,
    syncRequested: false,
    pendingTimer: null,
    currentPromise: null,
    lastCart: null,
    lastErrorSignature: '',
    pendingExpectedVariantId: 0,
    isRenderingGiftChange: false,
    miniCartRefreshPromise: null,
    campaignBoundaryTimer: null,
    productCache: {},
    reservedQuantityGiftProducts: {},

    refreshConfig: function () {
      var previous = this.config;
      this.config = readConfig();

      if (previous && this.config) {
        ['automatic', 'diaCliente', 'tagValueGift', 'tagQuantityGift', 'quantityGift2'].forEach(function (key) {
          var oldCampaign = previous[key];
          var newCampaign = manager.config[key];
          if (!oldCampaign || !newCampaign || oldCampaign.productId !== newCampaign.productId) return;

          if (oldCampaign.variantId) newCampaign.variantId = oldCampaign.variantId;
          if (oldCampaign.availabilityErrorUntil) {
            newCampaign.availabilityErrorUntil = oldCampaign.availabilityErrorUntil;
          }
          if (oldCampaign.variantAvailable === false && oldCampaign.availabilityErrorUntil > Date.now()) {
            newCampaign.variantAvailable = false;
          }
        });
      }

      this.scheduleCampaignBoundarySync();
      return this.config;
    },

    campaigns: function () {
      if (!this.config) return [];
      return [
        this.config.automatic,
        this.config.diaCliente,
        this.config.tagValueGift,
        this.config.tagQuantityGift,
        this.config.quantityGift2
      ].filter(Boolean);
    },

    scheduleCampaignBoundarySync: function () {
      var self = this;
      if (this.campaignBoundaryTimer) {
        window.clearTimeout(this.campaignBoundaryTimer);
        this.campaignBoundaryTimer = null;
      }

      var now = Date.now();
      var boundaries = [];

      this.campaigns().forEach(function (campaign) {
        if (!campaign || !campaign.enabled || !campaign.hasDateWindow) return;

        var start = campaignTimestamp(campaign.startDate, campaign.startTime, campaign.storeUtcOffset, false);
        var end = campaignTimestamp(campaign.endDate, campaign.endTime, campaign.storeUtcOffset, true);

        if (start !== null && start > now) boundaries.push(start);
        if (end !== null && end >= now) boundaries.push(end + 250);
      });

      if (!boundaries.length) return;

      var nextBoundary = Math.min.apply(Math, boundaries);
      var maxDelay = 2147000000;
      var delay = Math.max(250, Math.min(maxDelay, nextBoundary - now));

      this.campaignBoundaryTimer = window.setTimeout(function () {
        self.campaignBoundaryTimer = null;
        self.syncAfterAdd(0);
      }, delay);
    },

    properties: function (item) {
      return item && item.properties && typeof item.properties === 'object'
        ? item.properties
        : {};
    },

    itemKey: function (item) {
      return String(item && item.key ? item.key : '');
    },

    itemRole: function (item) {
      return String(this.properties(item)[ROLE_KEY] || '');
    },

    isThemeGift: function (item) {
      return THEME_GIFT_ROLES.indexOf(this.itemRole(item)) !== -1;
    },

    isCampaignGift: function (item, campaign) {
      return Boolean(item && campaign && this.itemRole(item) === campaign.role);
    },

    isSelectedCampaignGift: function (item, campaign) {
      return Boolean(
        item &&
        campaign &&
        campaign.variantId &&
        this.isCampaignGift(item, campaign) &&
        toNumber(item.variant_id || item.id) === campaign.variantId
      );
    },

    regularItems: function (cart) {
      var self = this;
      return cart && Array.isArray(cart.items)
        ? cart.items.filter(function (item) { return !self.isThemeGift(item); })
        : [];
    },

    regularQuantity: function (cart) {
      return this.regularItems(cart).reduce(function (total, item) {
        return total + Math.max(0, toNumber(item.quantity));
      }, 0);
    },

    regularSubtotal: function (cart) {
      return this.regularItems(cart).reduce(function (total, item) {
        return total + Math.max(0, toNumber(item.final_line_price));
      }, 0);
    },

    campaignIsInDateWindow: function (campaign) {
      if (!campaign) return false;
      if (!campaign.hasDateWindow) return true;
      if (!campaign.enabled) return false;

      var start = campaignTimestamp(campaign.startDate, campaign.startTime, campaign.storeUtcOffset, false);
      var end = campaignTimestamp(campaign.endDate, campaign.endTime, campaign.storeUtcOffset, true);
      var now = Date.now();

      if (campaign.startDate && start === null) return false;
      if (campaign.endDate && end === null) return false;
      if (start !== null && end !== null && end < start) return false;
      if (start !== null && now < start) return false;
      if (end !== null && now > end) return false;
      return true;
    },

    getItemHandle: function (item) {
      var handle = String(item && item.handle ? item.handle : '').trim();
      if (handle) return handle;

      var url = String(item && item.url ? item.url : '');
      var match = url.match(/\/products\/([^/?#]+)/i);
      return match ? decodeURIComponent(match[1]) : '';
    },

    productUrl: function (handle) {
      return rootUrl() + 'products/' + encodeURIComponent(handle) + '.js';
    },

    fetchProduct: function (handle, forceFresh) {
      var self = this;
      var key = String(handle || '').trim();
      if (!key) return Promise.resolve(null);

      var cached = this.productCache[key];
      var now = Date.now();
      if (!forceFresh && cached && cached.data && now - cached.time < PRODUCT_CACHE_TTL) {
        return Promise.resolve(cached.data);
      }
      if (!forceFresh && cached && cached.promise) return cached.promise;

      var promise = fetch(this.productUrl(key), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Não foi possível consultar o produto ' + key + '.');
          return response.json();
        })
        .then(function (product) {
          self.productCache[key] = { data: product, time: Date.now(), promise: null };
          return product;
        })
        .catch(function (error) {
          if (self.productCache[key]) self.productCache[key].promise = null;
          throw error;
        });

      this.productCache[key] = {
        data: cached && cached.data ? cached.data : null,
        time: cached && cached.time ? cached.time : 0,
        promise: promise
      };

      return promise;
    },

    readDomEligibility: function (item, campaign) {
      var key = this.itemKey(item);
      if (!key || !campaign) return null;

      var attribute = '';
      if (campaign.id === 'dia_cliente') attribute = 'data-dia-cliente-eligible';
      if (campaign.id === 'tag_value') attribute = 'data-beout-tag-value-eligible';
      if (campaign.id === 'tag_quantity') attribute = 'data-beout-tag-quantity-eligible';
      if (!attribute) return null;

      var rows = document.querySelectorAll('[data-cart-item-key]');
      for (var i = 0; i < rows.length; i += 1) {
        if (String(rows[i].getAttribute('data-cart-item-key') || '') !== key) continue;
        if (rows[i].hasAttribute(attribute)) {
          return String(rows[i].getAttribute(attribute) || '').toLowerCase() === 'true';
        }
      }
      return null;
    },

    readRuntimeState: function (campaign) {
      if (!campaign) return null;

      var node = null;
      if (campaign.id === 'dia_cliente') {
        node = document.querySelector('[data-beout-dia-cliente-runtime]');
      } else if (campaign.id === 'tag_value' || campaign.id === 'tag_quantity' || campaign.id === 'quantity_2') {
        node = document.querySelector('[data-beout-gift-runtime="' + campaign.id + '"]');
      }
      if (!node) return null;

      var productId = Math.max(0, toNumber(node.getAttribute('data-product-id')));
      var variantId = Math.max(0, toNumber(node.getAttribute('data-variant-id')));
      var available = String(node.getAttribute('data-variant-available') || '').toLowerCase() === 'true';

      return {
        productId: productId,
        productHandle: node.hasAttribute('data-product-handle')
          ? String(node.getAttribute('data-product-handle') || '').trim() : null,
        variantId: variantId,
        available: available,
        variantPrice: node.hasAttribute('data-variant-price')
          ? toNumber(node.getAttribute('data-variant-price'), -1) : null
      };
    },

    applyRuntimeState: function (campaign) {
      if (!campaign) return campaign;

      var runtime = this.readRuntimeState(campaign);
      if (!runtime) return campaign;
      var protection = window.beoutQuantityGiftProtection && window.beoutQuantityGiftProtection.getState();
      if (campaign.role === QUANTITY_2_ROLE && protection && protection.catalogChecked &&
          protection.productHandle === runtime.productHandle) {
        runtime.productId = protection.productId;
        runtime.variantId = protection.variantId;
        runtime.variantPrice = protection.variantPrice;
        runtime.available = protection.variantAvailable;
      }


      if (campaign.role === QUANTITY_2_ROLE && runtime.productHandle !== null) {
        if (campaign.productId !== runtime.productId) campaign.availabilityErrorUntil = 0;
        // A cleared picker must clear the old reservation, not keep a stale ID/handle.
        campaign.productId = runtime.productId;
        campaign.productHandle = runtime.productHandle;
        campaign.variantId = runtime.variantId;
      } else {
        if (runtime.productId) campaign.productId = runtime.productId;
        if (runtime.variantId) campaign.variantId = runtime.variantId;
      }
      campaign.variantAvailable = runtime.available;
      if (runtime.variantPrice !== null) campaign.variantPrice = runtime.variantPrice;
      return campaign;
    },

    itemHasRequiredTag: function (item, campaign) {
      var self = this;
      if (campaign && campaign.qualificationType === 'quantity_exclusions') {
        return this.itemQualifiesForQuantity2(item, campaign);
      }
      if (!item || !campaign || !campaign.requiredTag) return Promise.resolve(false);
      if (this.isThemeGift(item)) return Promise.resolve(false);
      if (campaign.productId && toNumber(item.product_id) === campaign.productId) return Promise.resolve(false);

      var domValue = this.readDomEligibility(item, campaign);
      if (domValue !== null) return Promise.resolve(domValue);

      var handle = this.getItemHandle(item);
      if (!handle) return Promise.resolve(false);

      return this.fetchProduct(handle, false)
        .then(function (product) {
          var tags = product && product.tags;
          if (typeof tags === 'string') tags = tags.split(',');
          if (!Array.isArray(tags)) return false;

          return tags.some(function (tag) {
            return String(tag || '').trim().toLowerCase() === campaign.requiredTag;
          });
        })
        .catch(function (error) {
          self.logErrorOnce(error);
          return false;
        });
    },

    readDomProductTags: function (item) {
      var key = this.itemKey(item);
      if (!key) return null;
      var rows = document.querySelectorAll('[data-cart-item-key]');
      for (var i = 0; i < rows.length; i += 1) {
        if (String(rows[i].getAttribute('data-cart-item-key') || '') !== key) continue;
        if (!rows[i].hasAttribute('data-beout-product-tags')) continue;
        try {
          var tags = JSON.parse(rows[i].getAttribute('data-beout-product-tags'));
          if (Array.isArray(tags)) return tags;
        } catch (error) {
          // A newly added row may not be rendered yet: use the product endpoint.
        }
      }
      return null;
    },

    itemQualifiesForQuantity2: function (item, campaign) {
      var self = this;
      if (!item || !campaign || this.isThemeGift(item)) return Promise.resolve(false);
      if (this.properties(item)._medidor_role === 'addon') return Promise.resolve(false);
      if (this.isReservedQuantityGiftProduct(item.product_id)) return Promise.resolve(false);
      if (campaign.productId && toNumber(item.product_id) === campaign.productId) return Promise.resolve(false);

      function qualifies(tags) {
        if (!Array.isArray(tags) && typeof tags !== 'string') return false;
        var normalized = normalizeTagList(tags);
        if (normalized.some(function (tag) { return campaign.excludedTags.indexOf(tag) !== -1; })) return false;
        return !campaign.requiredTag || normalized.indexOf(campaign.requiredTag) !== -1;
      }

      var domTags = this.readDomProductTags(item);
      if (domTags !== null) return Promise.resolve(qualifies(domTags));

      var handle = this.getItemHandle(item);
      if (!handle) return Promise.resolve(false);
      return this.fetchProduct(handle, false).then(function (product) {
        return qualifies(product && product.tags);
      }).catch(function (error) {
        self.logErrorOnce(error);
        return false;
      });
    },

    eligibleSubtotal: function (cart, campaign) {
      var self = this;
      var items = this.regularItems(cart);

      return Promise.all(items.map(function (item) {
        return self.itemHasRequiredTag(item, campaign).then(function (eligible) {
          return eligible ? Math.max(0, toNumber(item.final_line_price)) : 0;
        });
      })).then(function (values) {
        return values.reduce(function (total, value) { return total + value; }, 0);
      });
    },

    eligibleQuantity: function (cart, campaign) {
      var self = this;
      var items = this.regularItems(cart);

      return Promise.all(items.map(function (item) {
        return self.itemHasRequiredTag(item, campaign).then(function (eligible) {
          return eligible ? Math.max(0, toNumber(item.quantity)) : 0;
        });
      })).then(function (values) {
        return values.reduce(function (total, value) { return total + value; }, 0);
      });
    },

    isReservedQuantityGiftProduct: function (productId) {
      var id = toNumber(productId);
      return this.reservedQuantityGiftProducts[id] === true;
    },

    quantityGiftVariant: function (product, campaign) {
      if (!product || !campaign || !toNumber(product.id) || (campaign.productId && toNumber(product.id) !== campaign.productId) || !Array.isArray(product.variants)) {
        return null;
      }
      var variants = product.variants.filter(function (variant) {
        return toNumber(variant.price, -1) === campaign.expectedPriceCents;
      });
      // Deterministic selection, independent of the currently open product/variant URL.
      // An out-of-stock promotional variant still reserves the product, but cannot be added.
      return variants.find(function (variant) { return variant.available === true; }) || variants[0] || null;
    },

    refreshQuantityGiftReservations: function () {
      var self = this;
      var campaign = this.config && this.config.quantityGift2;
      this.reservedQuantityGiftProducts = {};
      if (!campaign) return Promise.resolve();

      this.applyRuntimeState(campaign);
      if (!campaign.productHandle) return Promise.resolve();
      var protection = window.beoutQuantityGiftProtection && window.beoutQuantityGiftProtection.getState();
      if (protection && protection.productHandle === campaign.productHandle && protection.reserved) {
        if (!campaign.productId) campaign.productId = protection.productId;
        // Keep confirmed protection even if a later catalog request fails.
        if (campaign.productId) this.reservedQuantityGiftProducts[campaign.productId] = true;
      }


      // Only the current selection belongs to this reservation. A previous gift
      // (including the necessaire) becomes a normal product when deselected.
      // Resolve the catalog price even when disabled/outside the campaign dates,
      // so manual copies cannot be purchased for R$0.10 without eligibility.
      return this.fetchProduct(campaign.productHandle, false).then(function (product) {
        if (!product || !Array.isArray(product.variants) || !toNumber(product.id)) return;
        if (campaign.productId && toNumber(product.id) !== campaign.productId) return;
        if (product.handle && product.handle !== campaign.productHandle) return;
        campaign.productId = toNumber(product.id);
        var variant = self.quantityGiftVariant(product, campaign);
        self.reservedQuantityGiftProducts[campaign.productId] = Boolean(variant);
        if (window.beoutQuantityGiftProtection) window.beoutQuantityGiftProtection.updateFromProduct(product);
        if (variant) {
          campaign.variantId = toNumber(variant.id);
          campaign.variantPrice = toNumber(variant.price, -1);
          campaign.variantAvailable = variant.available === true;
        }
      }).catch(function (error) {
        // An unavailable catalog must not remove a customer's normal purchase.
        self.logErrorOnce(error);
      });
    },

    resolveGiftVariantAvailability: function (campaign) {
      if (!campaign || !campaign.enabled || !campaign.productId) {
        return Promise.resolve(false);
      }

      if (campaign.availabilityErrorUntil && Date.now() < campaign.availabilityErrorUntil) {
        return Promise.resolve(false);
      }

      if (campaign.protectGiftProduct) this.applyRuntimeState(campaign);
      if (campaign.qualificationType === 'quantity_exclusions') {
        var self = this;
        // Verify catalog price/stock before every reconciliation (short shared cache).
        // This theme never substitutes a visual R$0.10 for a different real price.
        if (!campaign.productHandle) return Promise.resolve(false);
        return this.fetchProduct(campaign.productHandle, false).then(function (product) {
          var variant = self.quantityGiftVariant(product, campaign);
          if (!variant) {
            campaign.variantAvailable = false;
            return false;
          }
          campaign.variantId = toNumber(variant.id);
          campaign.variantAvailable = variant.available === true;
          campaign.variantPrice = toNumber(variant.price, -1);
          return campaign.variantAvailable && campaign.variantPrice === campaign.expectedPriceCents;
        }).catch(function (error) {
          self.logErrorOnce(error);
          return false;
        });
      }
      return Promise.resolve(Boolean(campaign.variantId && campaign.variantAvailable !== false));
    },

    evaluateCampaign: function (cart, campaign) {
      var self = this;
      var result = {
        campaign: campaign,
        shouldHave: false,
        eligibleSubtotal: 0,
        eligibleQuantity: 0
      };

      if (!campaign || !campaign.enabled || !campaign.productId || !campaign.variantId) {
        return Promise.resolve(result);
      }

      // A reserved R$0.10 product belongs only to the second quantity campaign.
      // Another campaign cannot re-add a duplicate under a different gift role.
      if (campaign.role !== QUANTITY_2_ROLE && this.isReservedQuantityGiftProduct(campaign.productId)) {
        return Promise.resolve(result);
      }

      if (!this.campaignIsInDateWindow(campaign)) return Promise.resolve(result);

      if (campaign.qualificationType === 'cart_value') {
        result.shouldHave = Boolean(
          campaign.minimumCents > 0 &&
          campaign.variantAvailable !== false &&
          this.regularQuantity(cart) > 0 &&
          this.regularSubtotal(cart) >= campaign.minimumCents
        );
        return Promise.resolve(result);
      }

      if (!campaign.requiredTag && campaign.qualificationType !== 'quantity_exclusions') return Promise.resolve(result);

      if (campaign.qualificationType === 'tag_quantity' || campaign.qualificationType === 'quantity_exclusions') {
        return Promise.all([
          this.eligibleQuantity(cart, campaign),
          this.resolveGiftVariantAvailability(campaign)
        ]).then(function (values) {
          result.eligibleQuantity = Math.max(0, toNumber(values[0]));
          result.shouldHave = Boolean(
            values[1] &&
            campaign.minimumQuantity > 0 &&
            result.eligibleQuantity >= campaign.minimumQuantity
          );
          return result;
        }).catch(function (error) {
          self.logErrorOnce(error);
          return result;
        });
      }

      return Promise.all([
        this.eligibleSubtotal(cart, campaign),
        this.resolveGiftVariantAvailability(campaign)
      ]).then(function (values) {
        result.eligibleSubtotal = Math.max(0, toNumber(values[0]));
        result.shouldHave = Boolean(
          values[1] &&
          campaign.minimumCents > 0 &&
          result.eligibleSubtotal >= campaign.minimumCents
        );
        return result;
      }).catch(function (error) {
        self.logErrorOnce(error);
        return result;
      });
    },

    evaluateCampaigns: function (cart) {
      var self = this;
      return this.refreshQuantityGiftReservations(cart).then(function () {
        return Promise.all(self.campaigns().map(function (campaign) {
          return self.evaluateCampaign(cart, campaign);
        }));
      });
    },

    getSectionsToRender: function () {
      var cartItems = document.querySelector('cart-items');
      if (cartItems && typeof cartItems.getSectionsToRender === 'function') {
        return cartItems.getSectionsToRender() || [];
      }

      var miniCart = document.querySelector('mini-cart');
      if (miniCart && typeof miniCart.getSectionsToRender === 'function') {
        return miniCart.getSectionsToRender() || [];
      }

      return [];
    },

    getSectionNames: function () {
      var names = [];
      this.getSectionsToRender().forEach(function (section) {
        var name = section.section || section.id;
        if (name && names.indexOf(name) === -1) names.push(name);
      });
      return names;
    },

    fetchCart: function () {
      return fetch(route('cart'), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      }).then(function (response) {
        if (!response.ok) throw new Error('Não foi possível consultar o carrinho.');
        return response.json();
      });
    },

    waitForCart: function (predicate, attempts, delay) {
      var self = this;
      var remaining = Math.max(0, toNumber(attempts));
      var wait = Math.max(0, toNumber(delay));

      return new Promise(function (resolve) {
        function run() {
          self.fetchCart()
            .then(function (cart) {
              if (!predicate || predicate(cart) || remaining <= 0) {
                resolve(cart);
                return;
              }

              remaining -= 1;
              window.setTimeout(run, wait);
            })
            .catch(function () {
              if (remaining <= 0) {
                resolve(null);
                return;
              }

              remaining -= 1;
              window.setTimeout(run, wait);
            });
        }

        run();
      });
    },

    expectedVariantFromResponse: function (response) {
      if (!response) return 0;
      if (typeof response.item_count !== 'undefined' || response.token) return 0;
      if (response.variant_id || response.id) {
        return Math.max(0, toNumber(response.variant_id || response.id));
      }
      if (Array.isArray(response.items) && response.items.length) {
        return Math.max(0, toNumber(response.items[0].variant_id || response.items[0].id));
      }
      return 0;
    },

    setBusy: function (busy) {
      document.documentElement.classList.toggle('beout-gift-is-syncing', Boolean(busy));
    },

    postRenderAdjustments: function () {
      document.querySelectorAll('[data-beout-automatic-gift="true"]').forEach(function (row) {
        row.querySelectorAll('cart-remove-button, quantity-input, .delete-product, [name="plus"], [name="minus"]').forEach(function (control) {
          control.hidden = true;
          control.setAttribute('aria-hidden', 'true');
          if ('disabled' in control) control.disabled = true;
        });
      });

      if (window.medidorCartSync && typeof window.medidorCartSync.postRenderAdjustments === 'function') {
        window.medidorCartSync.postRenderAdjustments();
      }

      if (window.SEInitCartDailyCountdown) {
        window.SEInitCartDailyCountdown(document);
      }
    },

    applyEmptyState: function (cart) {
      if (!cart || typeof cart.item_count === 'undefined') return;
      var isEmpty = toNumber(cart.item_count) === 0;

      document.querySelectorAll('cart-items').forEach(function (element) {
        element.classList.toggle('is-empty', isEmpty);
      });
      document.querySelectorAll('.mini-cart').forEach(function (element) {
        element.classList.toggle('is-empty', isEmpty);
      });

      var footer = document.getElementById('main-cart-footer');
      if (footer) footer.classList.toggle('is-empty', isEmpty);
    },

    applySections: function (state) {
      if (!state || !state.sections) return false;
      var rendered = false;

      this.getSectionsToRender().forEach(function (section) {
        var element = document.getElementById(section.id);
        var sectionHtml = state.sections[section.section] || state.sections[section.id];
        if (!element || !sectionHtml) return;

        var parsedDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
        var source = parsedDocument.querySelector(section.selector) || parsedDocument.querySelector('.shopify-section') || parsedDocument.body;
        var target = element.querySelector(section.selector) || element;

        if (target && source) {
          target.innerHTML = source.innerHTML;
          rendered = true;
        }
      });

      this.applyEmptyState(state);
      this.postRenderAdjustments();
      return rendered;
    },

    removeStaleGiftNodes: function (cart) {
      var self = this;
      var activeKeys = new Set(
        cart && Array.isArray(cart.items)
          ? cart.items.map(function (item) { return self.itemKey(item); }).filter(Boolean)
          : []
      );

      document.querySelectorAll('[data-beout-automatic-gift="true"]').forEach(function (node) {
        var row = node.matches('li, tr') ? node : node.closest('li, tr');
        if (!row) return;

        var key = row.getAttribute('data-cart-item-key') || row.getAttribute('bss-b2b-cart-item-key') || '';
        if (!key || !activeKeys.has(key)) row.remove();
      });
    },

    refreshMiniCartFromSection: function () {
      var self = this;
      var miniCart = document.getElementById('mini-cart');
      if (!miniCart) return Promise.resolve(null);

      if (this.miniCartRefreshPromise) return this.miniCartRefreshPromise;

      var mainBefore = miniCart.querySelector('.mini-cart__main');
      var previousScrollTop = mainBefore ? mainBefore.scrollTop : 0;
      var baseUrl = miniCart.getAttribute('data-url') || (rootUrl() + '?section_id=mini-cart');
      var separator = baseUrl.indexOf('?') > -1 ? '&' : '?';
      var url = baseUrl + separator + '_beout_gift=' + Date.now();

      this.miniCartRefreshPromise = fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'text/html' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Não foi possível atualizar o carrinho lateral.');
          return response.text();
        })
        .then(function (html) {
          var parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          var source = parsedDocument.querySelector('.shopify-section') || parsedDocument.body;
          if (!source) return null;

          miniCart.innerHTML = source.innerHTML;
          self.postRenderAdjustments();

          window.requestAnimationFrame(function () {
            var mainAfter = miniCart.querySelector('.mini-cart__main');
            if (mainAfter && previousScrollTop > 0) mainAfter.scrollTop = previousScrollTop;
          });

          return miniCart;
        })
        .catch(function (error) {
          self.logErrorOnce(error);
          return null;
        })
        .finally(function () {
          self.miniCartRefreshPromise = null;
        });

      return this.miniCartRefreshPromise;
    },

    visibleGiftRows: function () {
      return Array.prototype.slice.call(
        document.querySelectorAll('#mini-cart [data-beout-automatic-gift="true"]')
      );
    },

    miniCartLineCount: function () {
      return document.querySelectorAll(
        '#mini-cart #main-cart-items > cart-items > .mini-cart__navigation > li[data-cart-item-key], ' +
        '#mini-cart #main-cart-items > cart-items > .mini-cart__navigation > li[bss-b2b-cart-item-key]'
      ).length;
    },

    miniCartNeedsRefresh: function (cart) {
      var self = this;
      if (!document.getElementById('mini-cart') || !cart || !Array.isArray(cart.items)) return false;

      var cartGiftKeys = cart.items
        .filter(function (item) { return self.isThemeGift(item); })
        .map(function (item) { return self.itemKey(item); })
        .filter(Boolean);

      var visibleGiftKeys = this.visibleGiftRows()
        .map(function (row) {
          return row.getAttribute('data-cart-item-key') || row.getAttribute('bss-b2b-cart-item-key') || '';
        })
        .filter(Boolean);

      if (cartGiftKeys.length !== visibleGiftKeys.length) return true;
      if (cartGiftKeys.some(function (key) { return visibleGiftKeys.indexOf(key) === -1; })) return true;

      return this.miniCartLineCount() !== cart.items.length;
    },

    ensureMiniCartMatches: function (cart, force) {
      if (!document.getElementById('mini-cart')) return Promise.resolve(null);
      if (!force && !this.miniCartNeedsRefresh(cart)) return Promise.resolve(null);
      return this.refreshMiniCartFromSection();
    },

    buildProperties: function (campaign) {
      var properties = {};
      properties[ROLE_KEY] = campaign.role;
      properties[VARIANT_KEY] = String(campaign.variantId);
      properties[BADGE_KEY] = campaign.badgeText;
      properties[SOURCE_KEY] = campaign.source;
      return properties;
    },

    addGift: function (campaign) {
      var formData = new FormData();
      var properties = this.buildProperties(campaign);

      formData.append('id', String(campaign.variantId));
      formData.append('quantity', '1');

      Object.keys(properties).forEach(function (key) {
        formData.append('properties[' + key + ']', properties[key]);
      });

      var options = typeof window.fetchConfig === 'function'
        ? window.fetchConfig('javascript')
        : { method: 'POST', headers: { Accept: 'application/json' } };

      options.headers = options.headers || {};
      options.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete options.headers['Content-Type'];
      options.body = formData;

      return fetchJson(route('add'), options).catch(function (error) {
        if (campaign.protectGiftProduct && toNumber(error && error.status) === 422) {
          campaign.variantAvailable = false;
          campaign.availabilityErrorUntil = Date.now() + 30000;
        }
        throw error;
      });
    },

    updateLines: function (updates) {
      var options = typeof window.fetchConfig === 'function'
        ? window.fetchConfig()
        : {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            }
          };

      options.body = JSON.stringify({
        updates: updates,
        sections: this.getSectionNames(),
        sections_url: window.location.pathname
      });

      return fetchJson(route('update'), options);
    },

    renderChangedState: function (state) {
      var miniCart = document.querySelector('mini-cart');
      var pageCart = document.querySelector('#main-cart-items[data-id]');

      if (!pageCart && miniCart && typeof miniCart.renderContents === 'function' && state && state.sections) {
        this.isRenderingGiftChange = true;
        try {
          miniCart.renderContents(state);
        } finally {
          this.isRenderingGiftChange = false;
        }
        this.applyEmptyState(state);
        this.postRenderAdjustments();
        return true;
      }

      return this.applySections(state);
    },

    refreshSections: function () {
      var sectionNames = this.getSectionNames();
      if (!sectionNames.length) return Promise.resolve(null);

      var options = typeof window.fetchConfig === 'function'
        ? window.fetchConfig()
        : {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            }
          };

      options.body = JSON.stringify({
        updates: {},
        sections: sectionNames,
        sections_url: window.location.pathname
      });

      return fetchJson(route('update'), options).then(function (state) {
        manager.renderChangedState(state);
        return state;
      });
    },

    buildCampaignUpdates: function (cart, campaign, shouldHave) {
      var self = this;
      var updates = {};
      var items = cart && Array.isArray(cart.items) ? cart.items : [];
      var campaignItems = items.filter(function (item) {
        return self.isCampaignGift(item, campaign);
      });
      var selected = campaignItems.filter(function (item) {
        return self.isSelectedCampaignGift(item, campaign);
      });

      campaignItems.forEach(function (item) {
        if (!self.isSelectedCampaignGift(item, campaign)) {
          var wrongKey = self.itemKey(item);
          if (wrongKey) updates[wrongKey] = 0;
        }
      });

      if (campaign.role === QUANTITY_2_ROLE) {
        // At R$0.10 remove manual/foreign-role copies even below the threshold or disabled.
        // Keep this in the shared manager to avoid competing AJAX cart mutations.
        items.forEach(function (item) {
          if (!self.isReservedQuantityGiftProduct(item.product_id)) return;
          if (self.isSelectedCampaignGift(item, campaign)) return;
          var key = self.itemKey(item);
          if (key) updates[key] = 0;
        });
      }

      if (!shouldHave) {
        selected.forEach(function (item) {
          var key = self.itemKey(item);
          if (key) updates[key] = 0;
        });
        return updates;
      }

      if (selected.length) {
        var keeperKey = self.itemKey(selected[0]);
        if (keeperKey && toNumber(selected[0].quantity) !== 1) {
          updates[keeperKey] = 1;
        }

        selected.slice(1).forEach(function (item) {
          var key = self.itemKey(item);
          if (key) updates[key] = 0;
        });
      }

      /*
       * Proteção das campanhas com produto selecionável: enquanto a promoção
       * estiver elegível, qualquer linha manual do mesmo produto é removida.
       * A linha promocional permanece travada em exatamente 1 unidade.
       */
      if (campaign.protectGiftProduct && campaign.productId) {
        items.forEach(function (item) {
          if (self.isThemeGift(item)) return;
          if (toNumber(item.product_id) !== campaign.productId) return;
          var key = self.itemKey(item);
          if (key) updates[key] = 0;
        });
      }

      return updates;
    },

    mergeUpdates: function (target, source) {
      Object.keys(source || {}).forEach(function (key) {
        target[key] = source[key];
      });
      return target;
    },

    reconcile: function (cart, pass) {
      var self = this;
      var currentPass = toNumber(pass);
      if (!cart || !Array.isArray(cart.items) || currentPass >= MAX_PASSES) {
        return Promise.resolve(cart);
      }

      return this.evaluateCampaigns(cart).then(function (evaluations) {
        var updates = {};

        evaluations.forEach(function (evaluation) {
          self.mergeUpdates(
            updates,
            self.buildCampaignUpdates(cart, evaluation.campaign, evaluation.shouldHave)
          );
        });

        if (Object.keys(updates).length) {
          return self.updateLines(updates)
            .then(function (nextState) {
              self.lastCart = nextState;
              self.renderChangedState(nextState);
              self.removeStaleGiftNodes(nextState);
              return self.ensureMiniCartMatches(nextState, true).then(function () {
                return self.reconcile(nextState, currentPass + 1);
              });
            });
        }

        var missingCampaign = null;
        for (var i = 0; i < evaluations.length; i += 1) {
          var evaluation = evaluations[i];
          if (!evaluation.shouldHave) continue;
          if (!cart.items.some(function (item) {
            return self.isSelectedCampaignGift(item, evaluation.campaign);
          })) {
            missingCampaign = evaluation.campaign;
            break;
          }
        }

        if (!missingCampaign) {
          self.applyEmptyState(cart);
          self.postRenderAdjustments();
          return self.ensureMiniCartMatches(cart, false).then(function () {
            return cart;
          });
        }

        return self.addGift(missingCampaign)
          .then(function () {
            return self.waitForCart(function (nextCart) {
              return Boolean(nextCart && Array.isArray(nextCart.items) && nextCart.items.some(function (item) {
                return self.isSelectedCampaignGift(item, missingCampaign);
              }));
            }, 6, 120);
          })
          .then(function (cartWithGift) {
            if (!cartWithGift) return self.fetchCart();
            self.lastCart = cartWithGift;
            return self.refreshSections().then(function () {
              return self.ensureMiniCartMatches(cartWithGift, true);
            }).then(function () {
              return cartWithGift;
            });
          })
          .then(function (freshCart) {
            self.lastCart = freshCart;
            return self.reconcile(freshCart, currentPass + 1);
          });
      });
    },

    logErrorOnce: function (error) {
      var status = toNumber(error && error.status);
      var message = String(error && error.message ? error.message : error || 'Erro desconhecido');
      var signature = status + ':' + message;
      if (signature === this.lastErrorSignature) return;
      this.lastErrorSignature = signature;
      console.error('[Store Experts][Brindes] Falha na sincronização.', error);
    },

    syncFromState: function (state) {
      var self = this;
      var cart = parseCartState(state);
      this.refreshConfig();

      if (!this.config || !cart || !Array.isArray(cart.items)) {
        return Promise.resolve(cart);
      }

      if (window.medidorCartSync && window.medidorCartSync.isSyncing) {
        this.queueSync(null, 120);
        return Promise.resolve(cart);
      }

      if (this.isSyncing) {
        this.syncRequested = true;
        this.lastCart = cart;
        return this.currentPromise || Promise.resolve(cart);
      }

      this.isSyncing = true;
      this.syncRequested = false;
      this.lastCart = cart;
      this.setBusy(true);

      this.currentPromise = this.reconcile(cart, 0)
        .then(function (finalCart) {
          if (finalCart && Array.isArray(finalCart.items)) self.lastCart = finalCart;
          self.lastErrorSignature = '';
          return finalCart;
        })
        .catch(function (error) {
          self.logErrorOnce(error);
          return self.lastCart;
        })
        .finally(function () {
          self.isSyncing = false;
          self.currentPromise = null;
          self.setBusy(false);
          self.postRenderAdjustments();

          if (self.syncRequested) {
            self.syncRequested = false;
            self.syncAfterAdd(0);
          }
        });

      return this.currentPromise;
    },

    queueSync: function (state, delay) {
      var self = this;
      if (this.pendingTimer) window.clearTimeout(this.pendingTimer);

      this.pendingTimer = window.setTimeout(function () {
        self.pendingTimer = null;
        var parsed = parseCartState(state);
        if (parsed && Array.isArray(parsed.items)) {
          self.syncFromState(parsed);
        } else {
          self.syncAfterAdd(0);
        }
      }, typeof delay === 'number' ? delay : 60);
    },

    syncAfterAdd: function (delay, expectedVariantId) {
      var self = this;
      var expected = Math.max(0, toNumber(expectedVariantId));
      if (expected) this.pendingExpectedVariantId = expected;
      if (this.pendingTimer) window.clearTimeout(this.pendingTimer);

      this.pendingTimer = window.setTimeout(function () {
        self.pendingTimer = null;
        var expectedToFind = self.pendingExpectedVariantId;
        self.pendingExpectedVariantId = 0;

        self.waitForCart(function (cart) {
          if (!expectedToFind) return true;
          return Boolean(cart && Array.isArray(cart.items) && cart.items.some(function (item) {
            return toNumber(item.variant_id || item.id) === expectedToFind;
          }));
        }, expectedToFind ? 6 : 0, expectedToFind ? 180 : 0)
          .then(function (cart) {
            if (!cart) return null;
            return self.syncFromState(cart);
          })
          .catch(function (error) { self.logErrorOnce(error); });
      }, typeof delay === 'number' ? delay : 60);
    }
  };

  window.beoutGiftCartSync = manager;

  function initialize() {
    manager.refreshConfig();
    manager.postRenderAdjustments();
    manager.syncAfterAdd(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('cart:updated', function (event) {
    var cart = event && event.detail ? event.detail.cart : null;
    manager.queueSync(cart, 0);
  });

  document.addEventListener('ajaxProduct:added', function (event) {
    var response = event && event.detail ? event.detail.product : null;
    manager.syncAfterAdd(0, manager.expectedVariantFromResponse(response));
  });

  document.addEventListener('cartdrawer:opened', function () {
    manager.postRenderAdjustments();
    manager.syncAfterAdd(0);
  });

  document.addEventListener('cartdrawer:updated', function () {
    manager.postRenderAdjustments();
    manager.syncAfterAdd(0);
  });

  document.addEventListener('shopify:section:load', function () {
    manager.refreshConfig();
    manager.postRenderAdjustments();
    manager.syncAfterAdd(0);
  });

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      manager.syncAfterAdd(0, event.productVariantId);
    });
  } else if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || event.source !== 'product-form') return;
      manager.syncAfterAdd(0, event.productVariantId);
    });
  }

  /*
   * V14 — rede de segurança para carrinho AJAX.
   * Alguns apps e trechos personalizados alteram o carrinho sem disparar os
   * eventos nativos do tema. Observamos mutações em /cart/add, /cart/change e
   * /cart/update feitas por fetch ou XMLHttpRequest e sincronizamos em seguida.
   * As próprias chamadas do brinde também passam aqui, mas reconcile() é
   * idempotente: quando o carrinho já está correto nenhuma nova mutação ocorre.
   */
  function isCartMutationUrl(url) {
    var value = String(url || '');
    return /\/cart\/(?:add|change|update)(?:\.js)?(?:[?#]|$)/i.test(value);
  }

  if (typeof window.fetch === 'function' && !window.fetch.__beoutGiftV14Observed) {
    var nativeFetch = window.fetch.bind(window);
    var observedFetch = function () {
      var args = arguments;
      var requestUrl = args[0] && typeof args[0] === 'object' && args[0].url
        ? args[0].url
        : args[0];

      return nativeFetch.apply(null, args).then(function (response) {
        if (response.ok && isCartMutationUrl(requestUrl)) {
          window.setTimeout(function () { manager.syncAfterAdd(0); }, 40);
        }
        return response;
      });
    };
    observedFetch.__beoutGiftV14Observed = true;
    window.fetch = observedFetch;
  }

  if (window.XMLHttpRequest && !window.XMLHttpRequest.prototype.__beoutGiftV14Observed) {
    var nativeXhrOpen = window.XMLHttpRequest.prototype.open;
    var nativeXhrSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__beoutGiftV14CartMutation = isCartMutationUrl(url);
      return nativeXhrOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      if (this.__beoutGiftV14CartMutation) {
        this.addEventListener('loadend', function () {
          if (this.status < 200 || this.status >= 300) return;
          window.setTimeout(function () { manager.syncAfterAdd(0); }, 40);
        }, { once: true });
      }
      return nativeXhrSend.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.__beoutGiftV14Observed = true;
  }

  window.addEventListener('pageshow', function () {
    manager.syncAfterAdd(0);
  });
})();
